import ProgramPlanner from './containers/ProgramPlanner';
import requireAuth from '../../../utils/requireAuth';

// '/technical/program-planner' is already taken by the legacy Redux-based
// ProgramScheduler/ProgramTracker feature; this is mounted at its own path deliberately.
export const programPlannerRoutes = [
    {
        path: '/technical/planner-tracker',
        component: requireAuth(ProgramPlanner),
        key: 'SpartaPlanner',
    },
];
